import { useTranslation } from 'react-i18next';
import type { SettingsParamsType } from '@econtractor/types';
import ParamSwitch from '../ParamSwitch';

type ObjectsTabProps = {
    params: SettingsParamsType;
    isSaving: boolean;
    setParam: <K extends keyof SettingsParamsType>(key: K, value: SettingsParamsType[K]) => void;
};

const ObjectsTab = ({ params, isSaving, setParam }: ObjectsTabProps) => {
    const { t } = useTranslation(['Settings']);

    return (
        <div className="main-settings-fields">
            <ParamSwitch
                id="param-objectPaymentControl"
                label={t('mainParams.fields.objectPaymentControl.label')}
                description={t('mainParams.fields.objectPaymentControl.description')}
                checked={params.objectPaymentControl}
                disabled={isSaving}
                onChange={(v) => setParam('objectPaymentControl', v)}
            />
            <div className="border-top">
                <ParamSwitch
                    id="param-autoSyncPayStatus"
                    label={t('mainParams.fields.autoSyncPayStatus.label')}
                    description={t('mainParams.fields.autoSyncPayStatus.description')}
                    checked={params.autoSyncPayStatus}
                    disabled={isSaving || !params.objectPaymentControl}
                    onChange={(v) => setParam('autoSyncPayStatus', v)}
                />
            </div>
            <div className="border-top">
                <ParamSwitch
                    id="param-manualPayStatus"
                    label={t('mainParams.fields.manualPayStatus.label')}
                    description={t('mainParams.fields.manualPayStatus.description')}
                    checked={params.manualPayStatus}
                    disabled={isSaving || !params.objectPaymentControl}
                    onChange={(v) => setParam('manualPayStatus', v)}
                />
            </div>
            <div className="border-top">
                <ParamSwitch
                    id="param-lockFinishedObject"
                    label={t('mainParams.fields.lockFinishedObject.label')}
                    description={t('mainParams.fields.lockFinishedObject.description')}
                    checked={params.lockFinishedObject}
                    disabled={isSaving}
                    onChange={(v) => setParam('lockFinishedObject', v)}
                />
            </div>
            <div className="main-settings-subgroup border-top">
                <div className="main-settings-subgroup__head">
                    <div className="main-settings-subgroup__title">
                        {t('mainParams.subgroups.objectsReport.title')}
                    </div>
                    <div className="main-settings-subgroup__desc">
                        {t('mainParams.subgroups.objectsReport.description')}
                    </div>
                </div>

                <ParamSwitch
                    id="param-reportObjectsShowMaterials"
                    label={t('mainParams.fields.reportObjectsShowMaterials.label')}
                    description={t('mainParams.fields.reportObjectsShowMaterials.description')}
                    checked={params.reportObjectsShowMaterials}
                    disabled={isSaving}
                    onChange={(v) => setParam('reportObjectsShowMaterials', v)}
                />

                <div className="border-top">
                    <ParamSwitch
                        id="param-reportObjectsShowServices"
                        label={t('mainParams.fields.reportObjectsShowServices.label')}
                        description={t('mainParams.fields.reportObjectsShowServices.description')}
                        checked={params.reportObjectsShowServices}
                        disabled={isSaving}
                        onChange={(v) => setParam('reportObjectsShowServices', v)}
                    />
                </div>

                <div className="border-top">
                    <ParamSwitch
                        id="param-reportObjectsShowOther"
                        label={t('mainParams.fields.reportObjectsShowOther.label')}
                        description={t('mainParams.fields.reportObjectsShowOther.description')}
                        checked={params.reportObjectsShowOther}
                        disabled={isSaving}
                        onChange={(v) => setParam('reportObjectsShowOther', v)}
                    />
                </div>
            </div>
        </div>
    );
};

export default ObjectsTab;
